import React, { useState } from "react";
import "./auth.css";
import logo from "../../assets/home-logo.png";
import { Btn, FormInput, SuccessComp } from "../../utils/utils";
import { ArrowLeft } from "iconsax-react";
import { Link, useNavigate } from "react-router-dom";
import { AxiosPost } from "../../api/api";

const ForgotP = () => {
  const url = "auth/reset-password/code/";
  const navigate = useNavigate();
  const [emailAdd, setEmailAdd] = useState("");
  const [sucessMsg, setSucessMsg] = useState("");
  const [emailAddErr, setEmailAddErr] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleData = (e) => {
    setEmailAddErr("");
    setEmailAdd(e.target.value);
  };

  const dataObj = {
    email: emailAdd,
  };

  const clickReset = () => {
    setIsLoading(true);
    AxiosPost(url, dataObj)
      .then((res) => {
        // console.log(res);
        setSucessMsg(res.message);
        localStorage.setItem("reset-email", emailAdd);
        setTimeout(() => {
          navigate("/auth/otp");
          setSucessMsg("");
        }, 3000);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        setEmailAddErr(err?.response?.data?.errors[0].error);
        setIsLoading(false);
      });
  };

  return (
    <div className="forgot">
      <SuccessComp message={sucessMsg} />
      <img src={logo} alt="logo" />
      <div className="forgot-form">
        <h3>Forgot Password?</h3>
        <p>No worries, we’ll send you reset instructions</p>
        <FormInput
          type="email"
          label={"Email"}
          placeholder="Enter your Email"
          value={emailAdd}
          id={"emailAdd"}
          changeInput={handleData}
          err={emailAddErr}
        />
        <div className="forgot-btn_cont">
          <Btn
            btnClass={"home-btn"}
            btnText={"Reset Password"}
            btnClick={clickReset}
            btnWidth={"100%"}
            loading={isLoading}
          />
        </div>
        <Link to={"/auth/signin"} style={{ textDecoration: "none" }}>
          <div className="go-back">
            <ArrowLeft color="#444" size={24} />
            <p>Back to Login</p>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default ForgotP;
